// removed by extract-text-webpack-plugin
module.exports = {"oneStepCheckout":"_3WdtWpq9pQHbpe9uJmp9UK"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/startup/OneStepCheckout.scss
// module id = 829
// module chunks = 0